import "./brochure.css";

export default function BrochureForm({ onClose }) {

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    try {
      const response = await fetch("https://formspree.io/f/xpqegjbl", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (response.ok) {
        alert("Brochure request sent successfully!");
        e.target.reset();

        // ✅ safe close
        onClose?.();
      } else {
        alert("Something went wrong!");
      }
    } catch (error) {
      console.error(error);
      alert("Network error!");
    }
  };

  return (
    <div className="popup-overlay" id="broucher">
      <div className="popup-box">

        {/* ✅ CLOSE BUTTON (SAFE CALL) */}
        <button
          className="close-btn"
          onClick={() => onClose?.()}
        >
          ✕
        </button>

        <h2>Download Brochure</h2>
        <p>Fill the form and get brochure instantly.</p>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="name"
            placeholder="Name"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            required
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone"
          />

          <textarea
            name="message"
            placeholder="Message"
            rows="4"
            required
          />

          <button type="submit">Request Brochure</button>

        </form>

      </div>
    </div>
  );
}